import React from 'react';
import LOGA from '../../assets/logos/logo2.png'
import Az from '../../assets/logos/logo2.png'
import Tik from '../../assets/images/titok.png'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="footer " style={{backgroundImage:'url(images/assets/ban6.jpg)',}}>
      <div className="footer-main">
        <div className="container">
          <div className="row justify-content-between">
            {/* About Us Section */}
            <div className="col-lg-4 col-md-6 footer-widget footer-about">
              <h3 className="widget-title">Qui Sommes-Nous</h3>
              <img loading="lazy" style={{width:'100px'}} src={LOGA} alt="Constra" />
              <p>
             GEKAS Security and Consulting SARL est une entreprise de sécurité privée dynamique basée à Kinshasa, spécialisée dans la protection des biens, la sécurisation des sites sensibles, la protection rapprochée, ainsi que dans le conseil stratégique en sûreté et sécurité.
              </p>
             
            </div>

            {/* Working Hours Section */}
            <div className="col-lg-4 col-md-6 footer-widget mt-5 mt-md-0">
              <h3 className="widget-title">Heures</h3>
              <div className="working-hours">
              Nous sommes à votre disposition 7 jours sur 7. <br /> Notre équipe vous accueille et vous accompagne de manière personnalisée de 6h00 à 23h00, y compris les week-ends et jours fériés, pour vous garantir une assistance continue. 


                <br /> <br />

                Siège Social
1368, Saint Christophe, Funa-Limete,
KINSHASA RD-CONGO

Représentation
Kolwezi, Lubumbashi, Likasi, Matadi,
Isiro, Kalemie, Goma, Bukavu,
Washington (USA)
                
              </div>
            </div>

            {/* Services Section */}
            <div className="col-lg-3 col-md-6 mt-5 mt-lg-0 footer-widget">
              <h3 className="widget-title">Services</h3>
              <ul className="list-arrow">
                <li><Link to="/Securite-residentielle-industrielle">Sécurité résidentielle et industrielle</Link></li>
                <li><Link to="Protection-rapprochee">Protection rapprochée</Link></li>
                <li><Link to="/Surveillance-de-sites-minierse">Surveillance de sites miniers</Link></li>
                <li><Link to="/Transport-securise">Transport sécurisé</Link></li>
               
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="copyright" style={{backgroundColor:'#d8ba72'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="copyright-info text-center">
                <span>
                <img loading="lazy" style={{width:'100px'}} src={Az} alt="Constra" />
                </span>
              </div>
            </div>

          

           
          </div>

          {/* Back to Top Button */}
          <div id="back-to-top" data-spy="affix" data-offset-top="10" className="back-to-top position-fixed">
            <button className="btn btn-primary" title="Back to Top">
              <i className="fa fa-angle-double-up"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
